import { createAction } from "@reduxjs/toolkit";

export const appInitialized = createAction("app/initialized");
